/**
 * Try to use separate files in /components/
 *
 * IMPORTANT: If you want to use jQuery, make sure you enqueue it first.
 * Since it is only registered in actions.php
 */

import strlCursor from './components/cursor';
import './components/gravity-forms-fileupload-dropzone';
import './components/gravity-forms-readonly';
import './components/gravity-forms-address-autocomplete';
import './components/breakpoint-change';
import './components/offcanvas';
import './components/delay-search-queries';
import './components/lazy-gmaps';
import './components/footer-menus';
import './components/filter-dropdowns';
import './components/pagination';
import { hoverIntent } from './components/hover-intent';

const FANCYBOX_SELECTOR = '[data-popup-youtube], [data-popup-vimeo], .popup-gallery, [data-fancybox]';

/**
 * Load Fancybox vendor + bindings only when the page has lightbox triggers.
 */
function strlMaybeLoadFancybox() {
	if (!document.querySelector(FANCYBOX_SELECTOR)) {
		return;
	}

	import('./components/fancybox');
}

document.addEventListener('DOMContentLoaded', () => {
	let menuItems = document.querySelectorAll('#menu-main li.menu-item-has-children > a');
	// append translation menu to menu items
	const translationMenus = document.querySelectorAll('.translation-menu');
	if (translationMenus.length) {
		translationMenus.forEach((translationMenu) => {
			menuItems = [...menuItems, translationMenu.querySelector('button.translation-current')];
		});
	}
	if (menuItems.length) {
		hoverIntent(menuItems, {
			// required parameters
			onEnter: function (targetItem) {
				targetItem.classList.add('menu-item-visible');
			},
			onExit: function (targetItem) {
				targetItem.classList.remove('menu-item-visible');
			},
			// default options
			exitDelay: 400,
			interval: 100,
			sensitivity: 7,
		});
	}

	const emptyParagraphs = document.querySelectorAll('blockquote p:empty');
	emptyParagraphs.forEach((paragraph) => {
		paragraph.remove();
	});

	const collapsible = document.querySelector('.collapsible');

	if (collapsible) {
		if (typeof jQuery !== 'undefined') {
			jQuery(document).on('gform_post_render', function () {
				import('./components/gravity-forms-collapsible').then((module) => {
					module.initGravityAccordion();
				});
			});
		}
	}

	strlMaybeLoadFancybox();
	document.addEventListener('facetwp-loaded', strlMaybeLoadFancybox);

	document.addEventListener('keyup', (event) => {
		const target = event.target;
		if (!target || target.id !== 'searchbox' || !target.classList.contains('facetwp-search')) {
			return;
		}
		if (event.key !== 'Enter' && event.key !== 'NumpadEnter') {
			return;
		}
		if (typeof FWP === 'undefined') {
			return;
		}
		FWP.parseFacets();
		FWP.setHash();
		document.querySelector('.fwp-submit')?.click();
	});
});

window.addEventListener('load', () => {
	new strlCursor();

	const details = document.querySelectorAll('details');
	if (details.length) {
		import('./components/animate-details').then((module) => {
			module.initDetailsAnimation(document, false);
		});
	}
});
